export type ApiKeyRecord = {
  id: string;
  user: string;
  name: string;
  keyPrefix: string;
  lastUsedAt: string | null;
  created: string;
};

const KEY_PREFIX_LENGTH = 12;

function toBase64Url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Génère une clé API en clair côté client — jamais transmise ni stockée telle quelle. */
export function generateApiKey(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  return `sk_${toBase64Url(bytes)}`;
}

/** Hash SHA-256 en hex, seule forme persistée en base (via PocketBase). */
export async function hashApiKey(rawKey: string): Promise<string> {
  const data = new TextEncoder().encode(rawKey);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function apiKeyPrefix(rawKey: string): string {
  return rawKey.slice(0, KEY_PREFIX_LENGTH);
}
